import React, { FunctionComponent, ReactNode } from 'react'
import useStyles from './styles'
import { Heading, Grid, useMediaQuery } from '@conexasaude/hero-web'
import formSecBg from '@/assets/form-sec-bg.png'

export type LayoutProps = {
  children?: ReactNode
}

const Layout: FunctionComponent<LayoutProps> = ({ children }) => {
  const { imageStyle } = useStyles()
  const isDesktop = useMediaQuery('(min-width: 992px)')

  return (
    <Grid
      grow
      justify="center"
      align="stretch"
      gutter={60}
      sx={{ height: '100%', paddingTop: '24px' }}
    >
      <Grid.Col xs={12} md={6} lg={5}>
        <Heading variant="display" style={{ marginTop: '0' }}>
          {'Time Médico Conexa - Seleção Médica.'}
        </Heading>

        {isDesktop && <img css={imageStyle} src={formSecBg} alt={null} />}
      </Grid.Col>

      <Grid.Col xs={12} md={6} lg={7}>
        {children}
      </Grid.Col>
    </Grid>
  )
}

export default Layout
